import { useEffect, useRef, useState } from 'react'
import { useNotes, useUnread, type Note } from '../net/notify'
import { usePeople } from '../net/people'
import { useRoute, navigate } from '../app/router'
import { Avatar } from './Avatar'
import { Icon } from './Icon'
import { sfx } from '../lib/sound'

/* A friend's room invite pops up wherever you are (except mid-game), with Join right there. */
export function InvitePop() {
  useUnread() // keeps the live notification feed running everywhere
  const list = useNotes((s) => s.list)
  const route = useRoute()
  const seen = useRef<Set<number>>(new Set())
  const first = useRef(true)
  const [cur, setCur] = useState<Note | null>(null)
  useEffect(() => {
    // the first load is history, not news
    if (first.current) { if (list.length) { list.forEach((n) => seen.current.add(n.id)); first.current = false } return }
    const fresh = list.find((n) => n.kind === 'invite' && !seen.current.has(n.id) && Date.now() - new Date(n.created_at).getTime() < 120_000)
    list.forEach((n) => seen.current.add(n.id))
    if (fresh) { setCur(fresh); sfx('join') }
  }, [list])
  useEffect(() => {
    if (!cur) return
    const t = setTimeout(() => setCur(null), 30_000)
    return () => clearTimeout(t)
  }, [cur])
  const people = usePeople([cur?.data.from as string])
  if (!cur || route.name === 'game') return null
  const from = people[cur.data.from as string]
  const code = String(cur.data.code || '')
  if (route.name === 'room' && route.params.code?.toUpperCase() === code) return null
  return (
    <div className="invpop" role="status">
      <Avatar look={from || { name: '?', color: '#7650e0' }} size={40} ring={3} />
      <div className="t"><b>{from?.displayName || 'A friend'}</b><span>invited you to a {cur.data.kind === 'duo' ? 'duo' : 'game'}</span></div>
      <button className="btn btn-primary btn-sm" onClick={() => { setCur(null); navigate('/r/' + code) }}>Join</button>
      <button className="icon-btn" aria-label="Dismiss" onClick={() => setCur(null)}><Icon id="i-x" /></button>
    </div>
  )
}
